import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AttachmentManagementModalDispatchParams {
    parentType: 'document' | 'chapter' | 'section' | 'variant';
    parentId: number;
    parentName: string;
    canEdit: boolean;
}

export interface AttachmentManagementModalState {
    isOpen: boolean;
    data: AttachmentManagementModalDispatchParams | null;
}

const initialState: AttachmentManagementModalState = {
    isOpen: false,
    data: null,
};

export const attachmentManagementModalSlice = createSlice({
    name: 'attachment-management-modal',
    initialState,
    reducers: {
        open: (state, action: PayloadAction<AttachmentManagementModalDispatchParams>) => ({
            ...state,
            isOpen: true,
            data: action.payload,
        }),
        close: (state) => ({
            ...state,
            isOpen: false,
            data: null,
        }),
    },
});

export default attachmentManagementModalSlice.reducer;